import { supabase } from '@/integrations/supabase/client';

/** Runs em `running` há mais que isso são marcadas como erro (aba fechada, travamento, etc.). */
const STALE_AFTER_MS = 90 * 60 * 1000;

const STALE_MESSAGE =
  'Execução não concluiu no tempo esperado (interrupção, rede ou aba fechada). Tente novamente.';

/**
 * Fecha registros `task_agenda_runs` presos em `running` há muito tempo.
 * Chamado ao iniciar o runner para não deixar o histórico “em execução” para sempre.
 */
export async function markStaleTaskAgendaRuns(): Promise<number> {
  const cutIso = new Date(Date.now() - STALE_AFTER_MS).toISOString();
  const { data: stale, error: selErr } = await supabase
    .from('task_agenda_runs')
    .select('id')
    .eq('status', 'running')
    .lt('started_at', cutIso)
    .limit(50);

  if (selErr) {
    console.warn('[task_agenda] Falha ao listar runs antigas:', selErr.message);
    return 0;
  }
  if (!stale?.length) return 0;

  let n = 0;
  for (const row of stale) {
    const { error: upErr } = await supabase
      .from('task_agenda_runs')
      .update({
        finished_at: new Date().toISOString(),
        status: 'error',
        summary: null,
        error_message: STALE_MESSAGE,
      })
      .eq('id', row.id)
      .eq('status', 'running');
    if (!upErr) n++;
  }
  if (n > 0) {
    console.warn(`[task_agenda] ${n} execução(ões) antiga(s) marcada(s) como erro (estavam em "running").`);
  }
  return n;
}
